export const moFlo = {
  position: {
    occupationGroups: {
      header: 'Select a position',
      description: "Don't see the position you need?",
      whatPositionsDoYouNeed: 'What position do you need?',
      whatPositionsDoYouNeedDesc:
        'After selecting a position, you can customize its details and name to best fit your needs.',
      searchLabel: 'Position',
      searchPlaceholder: 'Search for a position',
      emptyDescription: 'Try using a different keyword for your search.',
      creatingPosition: "We're creating your position...",
    },
    review: {
      headers: {
        keyResponsibilities: 'Key Responsibilities',
        mandatoryQualifications: 'Mandatory Qualifications',
        requiredSkills: 'Required Skills',
        workContext: 'Work Context',
        dressCode: 'Clothing/Equipment Details',
        summary: 'Position Summary',
        additionalInformation: 'Additional Information',
        editKeyResponsibilities:
          'Edit the key responsibilities of this position',
        editName: 'Edit the position name',
        editMandatoryQualifications:
          'Edit the mandatory qualifications of this position',
        editRequiredSkills: 'Edit the required skills of this position',
      },

      keyResponsibilities: {
        description:
          "Outline the primary duties for this position so Wonoloers know what they'll be doing.",
        limitReachedTitle: "You've reached the limit of 8",
        limitReachedDescription:
          'Only choose ones that match this position best. If needed, you can pick new ones by unselecting others.',
        keyResponsibilitiesRequired:
          'Please choose at least one key responsibility for this position',
        searchDescription:
          "If you can't find what you're looking for, search for additional choices.",
        searchLoadingText: 'Our AI assistant is searching over 18,000 job responsibilities to bring you the best results. This may take a few seconds.',
        searchNoResultsText: 'No results, can you be more specific.',
        searchPlaceholder: 'Search to get started.',
        searchLabel: 'Search key responsibilities',
      },
      name: {
        headerDescription:
          "Here's a sample job description based on the position you've selected. Feel free to adjust anything as needed.",
        inputDescription:
          'This is the name that you and Wonoloers will see on the job.',
        emptyTitleError: 'Your position name cannot be blank',
        maxLimitReached: 'You cannot exceed 40 characters.',
      },
      mandatoryQualifications: {
        description:
          "List this position's must-have licenses or certifications. In addition to a background check, we'll screen for these, which means too many qualifications can impact your fill rate",
        limitReachedTitle: "You've reached the limit of 4",
        limitReachedDescription:
          'Only choose qualifications that are absolutely required. You can pick different qualifications by unselecting others.',
        searchDescription:
          "If you can't find what you're looking for, search for additional choices.",
      },
      requiredSkills: {
        editRequiredSkillsDescription:
          'Only choose things that are needed for the Wonoloer to be effective in this position.',
        description:
          "List any skills or knowledge the Wonoloer should have for this position. We'll inform and educate them based on this criteria.",
      },
      workContext: {
        description:
          "Describe the position's setting and social interactions so Wonoloers know what to expect.",
        editWorkContext: 'Edit the work context of this position',
        editWorkContextDescription:
          'Only choose the things that are really important and happen regularly. This helps Wonoloers make important decisions when accepting jobs.',
        searchDescription:
          "If you can't find what you're looking for, search for additional choices.",
        limitReachedTitle: "You've reached the limit of 10",
        limitReachedDescription:
          'Only choose ones that match this position best. If needed, you can pick new ones by unselecting others.',
      },
      dressCode: {
        description: 'Indicates how Wonoloers should dress for this position.',
        editDressCodeTitle: 'Edit clothing/equipment details',
        noPreference: 'No preference',
        clothingRequirements: 'Clothing requirements',
        clothingRestrictions: 'Clothing restrictions',
        environment: 'Environment',
      },
      additionalInformation: {
        description:
          'Includes anything else you want Wonoloers to know about this position.',
        editAdditionalInformation: 'Edit additional information',
        editAdditionalInformationDescription:
          'Include anything you want Wonoloers to know about the position.',
        additionalInformationLabel: 'Enter additional information',
      },
      summary: {
        description: 'Summarize the most important details for Wonoloers, e.g., working conditions, required skills, or any specific requirements.',
        editSummary: 'Key Job Information',
        editSummaryDescription: 'Summarize the most important details for Wonoloers, e.g., working conditions, required skills, or any specific requirements. Provide key information that will help Wonoloers decide if this job is the right fit for them.',
        summaryLabel: 'Enter Key Job Information...',
      }
    },
    rampUp: {
      header:
        'Will significant time or resources be needed for someone to reach full productivity in this job?',
      description:
        'We want to know if this position demands a significant time investment (ie: 3 days) to ensure Wonoloers can effectively perform the job.',
      yes: "Yes, there's a learning curve.",
      no: 'No, Wonoloers can hit the ground running',
      error: 'Please let us know if you have any ramp up requirements.',
      learnMoreText: 'Have any questions about this?',
    },
  },
  location: {
    header: "Tell us about the job's location",
    dropdownLabel: 'Location',
    createNewLocation: 'Create new location',
    parkingInstructionsHeader: 'Parking Instructions',
    entranceInstructionsHeader: 'Entrance Instructions',
    additionalInstructionsHeader: 'Additional Instructions',
    contactsHeader: 'Contacts',
    noContactsAlertHeader: 'This location is missing a contact',
    noContactsAlertDescription: 'Contacts are helpful for Wonoloers to know who to reach out to for any issues or questions.',
    addContactPrompt: 'Add a contact',
    selectLabel: 'Where is the location?',
  },
  schedule: {
    header: {
      setup: 'Set up your schedule',
    },
    oneOff: {
      date: {
        header: 'What days do you need?',
        startDateLabel: 'Start date',
        endDateLabel: 'End date',
        totalDaysLabel: 'TOTAL WORKDAYS',
      },
      time: {
        header: 'What times do you need?',
        startLabel: 'Start time',
        endLabel: 'End time',
        breakInputLabel: 'Unpaid break',
        breakLabel: 'Select duration',
        overnight: 'This is an overnight job and will end on %date%',
      },
      customize: {
        alert: {
          button: 'Customize',
          title: 'Customize your schedule',
          body: 'You can customize your schedule by changing any times or unpaid breaks on specific days as necessary to accommodate your labor needs.',
        },
        modal: {
          title: 'Customize your schedule',
          body: 'You can adjust times or unpaid breaks as needed to fit your labor needs. Start by selecting the calendar day in your schedule and then begin making any necessary adjustments.',
        },
      },
      validationErrors: {
        missingStartTime: 'Please select a start time',
        missingEndTime: 'Please select an end time',
        unpaidTimeLessThanZero: 'Unpaid time cannot be less than 0',
        paidTimeGreaterThanTwentyFourHours:
          'Job duration cannot be greater than 24 hours',
        unpaidTimeGreaterThanPaidTime:
          'Unpaid breaks duration cannot exceed 50% of the working hours',
        startTimeInThePast: 'Start time must be in the future',
      },
    },
    recurring: {
      selectExisting: {
        createNew: 'Create new schedule',
        selectTime: 'You can make customizations this schedule',
        whichSchedule: 'What schedule do you want to use?',
        chooseSchedule: 'Choose a schedule',
      },
      date: {
        header: 'What days should your schedule follow?',
        subheader:
          'Select your dates and then tell us which days you want your schedule to repeat. You will be able to customize times as needed.',
        startDateLabel: 'Start date',
        endDateLabel: 'End date',
        totalDaysLabel: 'TOTAL WORKDAYS',
      },
      time: {
        header: 'What times does your schedule follow?',
        startLabel: 'Start time',
        endLabel: 'End time',
        breakInputLabel: 'Unpaid break',
        breakLabel: 'Select duration',
        overnight: 'This is an overnight job and will end on %date%',
      },
      name: {
        label: 'Name your schedule.',
        name: 'Schedule Name',
        placeholder: 'Enter a name for your schedule...',
      },
      namePlaceholder: 'Enter a name for your schedule...',
      validation: {
        startTimeError: 'Start time cannot be after or the same as end time',
        nameMissing: 'Name is a required field',
        nameTooLong: 'Name cannot exceed 250 characters',
        missingTimeDetails: 'Please enter the missing shift time details',
        unpaidTimeLessThanZero: 'Unpaid time cannot be less than 0',
        unpaidTimeGreaterThanTwentyFourHours:
          'Unpaid time cannot be greater than 24 hours',
        paidTimeGreaterThanTwentyFourHours:
          'Job duration cannot be greater than 24 hours',
        unpaidTimeGreaterThanPaidTime:
          'Unpaid breaks duration cannot exceed 50% of the working hours',
        invalidDay: "This is a %day% and doesn't match days selected",
      },
      customize: {
        alert: {
          button: 'Customize',
          title: 'Customize your schedule',
          body: 'You can customize your schedule by changing any times or unpaid breaks on specific days as necessary to accommodate your labor needs.',
        },
        modal: {
          title: 'Customize your schedule',
          body: 'You can adjust times or unpaid breaks as needed to fit your labor needs. Start by selecting the calendar day in your schedule and then begin making any necessary adjustments.',
          dayOfWeek: 'Make changes for all %day%s in your schedule',
        },
      },
      validationErrors: {
        endDateBeforeStartDate: 'End date cannot be before start date',
        startTimeError: 'Start time cannot be the same as end time',
        nameMissing: 'Name is a required field',
        nameTooLong: 'Name cannot exceed 40 characters',
        missingTimeDetails: 'Please enter the missing shift time details',
        unpaidTimeLessThanZero: 'Unpaid time cannot be less than 0',
        paidTimeGreaterThanTwentyFourHours:
          'Job duration cannot be greater than 24 hours',
        unpaidTimeGreaterThanPaidTime:
          'Unpaid breaks duration cannot exceed 50% of the working hours',
        daysOfWeekMissing: 'Select at least one day of the week',
        startDateInPast: 'Start date cannot be in the past',
        startTimeInPast: 'Start time cannot be in the past',
      },
    },
  },
  workers: {
    header: 'Let us know what Wonoloers you need',
    slots: {
      slotsLabel: 'How many Wonoloers do you need?',
      sameWorkersPlural:
        'Do you need the same Wonoloers to accept all %workDays% of the workdays?',
      sameWorkers: 'Do you need the same Wonoloers to accept the workday?',
      sameWorkersTrue: 'Yes, I need the same Wonoloers every day',
      sameWorkersFalse: 'No, I can have different Wonoloers show up',
      tempToHireDescription:
        'Let Wonoloers know if this job could lead to a permanent employment opportunity',
    },
    preferences: {
      summary: {
        slots: '%slots% Wonoloer',
        sameWorker: 'The same Wonoloer must accept all %workDays% workday',
        nonSameWorker:
          'Different Wonoloers can show up on any of the %workDays% workday',
      },
      label: 'Who can accept this job?',
      options: {
        goodStanding: {
          title: 'Qualified Wonoloers in Good Standing',
          description:
            "We'll open it up to all qualified Wonoloers, starting with those who are ranked the highest.",
          pros: 'Best for balancing fill rate with quality',
        },
        specificWonoloers: {
          title: 'Specific Wonoloers',
          description:
            'You decide who to notify first, and whether you want to limit the job to only those Wonoloers.',
          pros: 'Best when you want more control',
          cons: 'May increase risk of low fill rate',
        },
        allWonoloers: {
          title: 'All Qualified Wonoloers',
          description:
            "We'll open it up to all Wonoloers, including those who aren't as consistent on our platform.",
          pros: 'Best when fill rate matters most',
          cons: 'May increase risk of No Shows',
        },
      },
      preferredTeamLabel: 'Select who you want to be notified.',
      preferredTeamDescription:
        'Add the specific Wonoloers that you want to notify about this job. If you choose to only notify specific Wonoloers and they do not accept, then your job will not be filled.',
      addWonoloers: 'Add Wonoloers',
      manageWonoloers: 'Manage Wonoloers',
      noTeamsDescription:
        "You haven't created any Teams yet. Once you do, you can decide who to notify first among Wonoloers, and whether you want to limit the job to only those Wonoloers.",
    },
  },
  pay: {
    alert: {
      title: 'Verify your pay rate',
      description:
        "Because you've changed some job details, we need you to review your pay. If needed, please adjust your pay rate for this job.",
    },
    header: 'Set your pay rate',
    errors: {
      flatRate:
        "$%minimumPay% is the minimum wage in %city%, %stateCode% based on your job's schedule. You cannot post a job lower than this.",
      hourly:
        '$%minimumPay% is the minimum hourly pay for %city%, %stateCode%. You cannot post a job lower than this.',
    },
    breakdown: {
      header: 'Your payment breakdown',
      averagePay: 'Average daily pay per Wonoloer',
      totalPay: 'Total pay per Wonoloer:',
      totalCost: 'Total Wonoloer cost:',
      serviceCharge: 'Service charge:',
      estimatedTotal: 'Est. total job cost:',
      disclaimer:
        '* The estimated total job cost may increase or decrease depending on the slots filled and the hours of work completed by Wonoloers.',
      wonoloersAndSlots: '%wonoloers% Wonoloers x %slots% workday(s)',
    },
  },
  review: {
    location: {
      header: 'LOCATION',
      parkingInstructionsHeader: 'Parking Instructions',
      entranceInstruction: 'Entrance Instructions',
      additionalInstructions: 'Additional Instructions',
      addLocation: 'Please add a location for this job',
      contactsHeader: 'Contacts'
    },
    position: {
      header: 'POSITION',
    },
    pay: {
      header: 'PAY',
    },
    wonoloers: {
      header: 'WONOLOERS',
      wonoloersPerWorkday: 'Wonoloers per workday',
      whoCanAccept: 'Who can accept?',
      wonoloerRequirements: 'Wonoloer Requirements',
      tempToHire: 'Temp-to-hire?',
      goodStanding: 'Wonoloers in good standing',
      specificWonoloers: 'Specific Wonoloers',
      closedPreferred: 'Only notify specific Wonoloers',
      openPreferred: 'Notify specific Wonoloers first',
      allQualified: 'All qualified Wonoloers',
      sameWorkers: 'Same Wonoloer',
      nonSameWorkers: 'Non same Wonoloer',
    },
    schedule: {
      header: 'SCHEDULE',
      dateRange: '%startDate% - %endDate%',
      workdays: '%workdays% Workday',
      viewInCalendar: 'View in calendar',
      addSchedule: 'Please add a schedule for this job',
    },
    postJob: 'Post job',
    postingYourJob: "We're posting your job...",
  },
};
